<template>
    <div style="padding: 20px;height: 100%;width: 100%">
        <div class="titleBox" style="display: flex;align-items: center;">
            <img src="../../../assets/img/icon.png" alt="" style="width: 24px">
            <h3>订单统计</h3>
        </div>
        <div class="left_box3">
                <dv-scroll-board
                    :config="board_info"
                    class="carousel_list"
                    oddRowBGC="#fff"
                />
        </div>

    </div>
</template>

<script>
export default {
    name:'orderStatistics',
    props:['echartsData'],
    data(){
        return{
            board_info:{
                header: ["月份", "订单总金额"],
                data: [],
                evenRowBGC: "#020308",
                oddRowBGC: "linear-gradient(to right, #ffffff, #f0f5ff)",
                headerBGC: "transparent",
                index:true,
                indexHeader: "序号",
                columnWidth: [150],
                align: ['center'],
                hoverPase: true,
            },
            // 可选：用于强制更新组件的key
            boardKey: 0
        }
    },
    watch:{
        echartsData: {
            handler(newVal) {
                // 方法1：替换整个对象，确保响应式更新
                this.board_info = {
                    ...this.board_info,
                    data: newVal.order_data_arr
                };
            },
            deep: true,
            immediate: true // 确保初始数据也处理
        }
    },
    // 如果初始数据需要处理
    created() {
        if (this.echartsData.order_data_arr) {
            this.board_info.data = this.echartsData.order_data_arr;
        }
    }
}
</script>

<style scoped lang="scss">
.titleBox{
    img{
        margin-right: 10px;
    }
}
.left_box3{
    height: 80%;
}
::v-deep.dv-scroll-board .rows { background: linear-gradient(to right,rgba(#14253E,0.1) 0%, rgba(#153058,0.8) 50%, rgba(#14253E,0.1) 100%); }
</style>